import React from "react";
import { TransactionViewContainer } from "../../../containers";

const TransactionView = (props) => {
  return <TransactionViewContainer {...props} />;
};

export default TransactionView;
